import React from 'react'
import './insider-minicart-skeleton.scss'

interface LoadingProps {
  /** Mensagem de carregamento personalizada */
  message?: string
}

export default function InsiderMinicartSkeleton({
  message = 'Carregando recomendações…',
}: LoadingProps) {
  return (
   <div className="insider-skeleton-card-minicart">
      <div className="skeleton-image" />
      <div className="skeleton-line" />
      <div className="skeleton-line short" />
      <div className="skeleton-price" />
    </div>
  )
}
